import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';

export type StornoPatientElectronicPrescriptionParams =
	InsuredPatientCommandParams & {
		prescriptionCode: string;
	};

export const StornoPatientElectronicPrescription = (
	params: StornoPatientElectronicPrescriptionParams,
): Command => {
	return {
		operation: 'StornujPreskripcnyZaznam_v6',
		params,
	};
};
